import React, { useEffect } from "react";
import UIBody from "../../../components/ui/UIBody";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../routes/api/apiRoutes";

const ProjectsList = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    callAPI("get", apiRoutes.webiste.project, "");
  }, []);

  return (
    <UIBody
    loading={loading}
      content={
        <div>
          {/* Header Section */}
          <div className="row">
            <div className="section-header text-center">
              <div className="section__title text-center mb-40">
                <span className="sub-title">Projects</span>
                <h2 className="title">Recent Work</h2>
                <p className="desc">
                  We take pride in delivering innovative solutions that drive
                  business growth and digital transformation.
                </p>
              </div>
            </div>
          </div>

          {/* Loading / Error */}
         

        

          {/* Dynamic Choose Sections */}
          <div className="container">
            {Array.isArray(responce?.data) && responce.data.map((project, index) => (
              <section key={index} className="choose__area tg-motion-effects py-5">
                <div className="container">
                  <div className="choose__inner-wrap">
                    <div className="row">
                      {/* Image on Right */}
                      <div className="col-lg-5 order-0 order-lg-2">
                        <div
                          className="choose__img"
                          data-aos="fade-left"
                          data-aos-delay="300"
                        >
                          <img
                            src={project.image || "https://via.placeholder.com/400x300"}
                            alt={project.name}
                          />
                        </div>
                      </div>

                      {/* Content on Left */}
                      <div className="col-lg-7">
                        <div className="choose__content">
                          <div className="section__title mb-15">
                            <span className="sub-title">Project Highlight</span>
                            <h2 className="title">{project.name}</h2>
                             <div className="mb-2">
  {project.technology?.split(",").map((tech, i) => (
    <span key={i} className="badge bg-secondary me-2">
      {tech.trim()}
    </span>
  ))}
</div>


                          </div>
                          <p>{project.description || "No description available."}</p>
                          <div className="shape">
                            <img
                              src="assets/img/others/choose_shape03.svg"
                              alt="shape"
                              className="tg-motion-effects4"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Decorative Shapes */}
                <div className="choose__shape">
                  <img
                    src="assets/img/others/choose_shape01.svg"
                    alt="shape"
                    className="tg-motion-effects4"
                  />
                  <img
                    src="assets/img/others/choose_shape02.svg"
                    alt="shape"
                    className="tg-motion-effects5"
                  />
                </div>
              </section>
            ))}
          </div>
        </div>
      }
    />
  );
};

export default ProjectsList;